// src/pages/Cart.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";

export default function Cart() {
  const { items, total, dispatch } = useCart();
  const navigate = useNavigate();

  const formatPrice = p =>
    new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 }).format(p);

  const ENVIO = total >= 150000 ? 0 : 12000;

  if (items.length === 0) return (
    <div className="empty-cart page-pad">
      <div className="empty-icon">🛒</div>
      <h2>Tu carrito está vacío</h2>
      <p>Agrega productos desde nuestra tienda para continuar.</p>
      <Link to="/tienda" className="btn-primary">Ir a la tienda</Link>
    </div>
  );

  return (
    <div className="cart-page page-pad">
      <h1>Mi carrito</h1>

      <div className="cart-layout">
        <div className="cart-items">
          {items.map(item => (
            <div key={item.id} className="cart-item">
              <img
                src={item.images?.[0] || "/placeholder.jpg"}
                alt={item.name}
                onError={e => { e.target.src = "/placeholder.jpg"; }}
              />
              <div className="item-info">
                <Link to={`/producto/${item.id}`}><h3>{item.name}</h3></Link>
                <span>{item.category}</span>
                <span className="item-price">{formatPrice(item.price)}</span>
              </div>
              <div className="item-controls">
                <div className="qty-control">
                  <button onClick={() => dispatch({ type: "UPDATE_QTY", payload: { id: item.id, qty: item.quantity - 1 } })}>−</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => dispatch({ type: "UPDATE_QTY", payload: { id: item.id, qty: item.quantity + 1 } })}>+</button>
                </div>
                <span className="item-subtotal">{formatPrice(item.price * item.quantity)}</span>
                <button
                  className="remove-btn"
                  onClick={() => { dispatch({ type: "REMOVE_ITEM", payload: item.id }); toast("Producto eliminado"); }}
                  aria-label="Eliminar"
                >✕</button>
              </div>
            </div>
          ))}
        </div>

        <aside className="cart-summary">
          <h3>Resumen del pedido</h3>

          <div className="summary-row">
            <span>Subtotal</span>
            <span>{formatPrice(total)}</span>
          </div>
          <div className="summary-row">
            <span>Envío</span>
            <span>{ENVIO === 0 ? "¡Gratis!" : formatPrice(ENVIO)}</span>
          </div>
          {ENVIO > 0 && (
            <p className="shipping-hint">
              Agrega {formatPrice(150000 - total)} más para envío gratis
            </p>
          )}
          <div className="summary-total">
            <span>Total</span>
            <span>{formatPrice(total + ENVIO)}</span>
          </div>

          <button className="btn-primary btn-full" onClick={() => navigate("/checkout")}>
            Proceder al pago
          </button>
          <Link to="/tienda" className="btn-ghost btn-full">Seguir comprando</Link>

          <div className="security-badges">
            <span>🔒 Pago 100% seguro</span>
            <span>📦 Envío asegurado</span>
          </div>
        </aside>
      </div>
    </div>
  );
}
